import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import { Box, Button, Container, CopyToClipboard, FileUpload, Grid, Input, Modal, SpaceBetween, StatusIndicator, Tabs } from "@amzn/awsui-components-react";
import { Link } from "react-router-dom";
import firstpassLogo from '../../../images/firstpassLogo.png'
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Storage } from 'aws-amplify';
import { AgGridReact } from 'ag-grid-react';
import { useHistory } from "react-router-dom";
import {getFirstPassHistoryItem, listFirstPassEntities } from "src/Ateam-BI/Templates/Utils/AppActivityUtilsAppsyncPlus";
import { convertToLocalTime } from "src/Ateam-BI/CorpReporting/Utility";
import FirstPassResultComponent from "./FirstPassResultComponent";
import { configureFSS3 } from "src/context/AuthContextUtility";
import { v4 as uuidv4 } from 'uuid';

const FirstPassPollAndPullResults = ({ requestId, data }) => {
  const [result, setResult] = useState(null);
  const [isPolling, setIsPolling] = useState(true);
  const [error, setError] = useState(null);
  const [displayCount, setDisplayCount] = useState(0); // For UI display
  const retryCountRef = useRef(0); // For logic

  const MAX_RETRIES = 180;

  useEffect(() => {
    let isMounted = true;
    let timeoutId;

    const poll = () => {
      if (retryCountRef.current >= MAX_RETRIES) {
        if (isMounted) {
          setError('Timeout');
          setIsPolling(false);
        }
        return;
      }

      getFirstPassHistoryItem(
        requestId,
        function onSuccess(response) {
          const responseData = response?.data?.getFirstPassHistoryItem;

          if (!isMounted) return;

          if (responseData) {
            setResult(responseData);
            setIsPolling(false);
          } else {
            retryCountRef.current += 1;
            setDisplayCount(retryCountRef.current); // Update UI
            timeoutId = setTimeout(poll, 1000);
          }
        },
        function onFailure(err) {
          if (isMounted) {
            retryCountRef.current += 1;
            setDisplayCount(retryCountRef.current); // Update UI
            timeoutId = setTimeout(poll, 1000);
          }
        }
      );
    };

    poll();

    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, [requestId]);

  if (error) {
    return (
      <Box>
        <StatusIndicator type="error">{error}</StatusIndicator>
      </Box>
    );
  }

  if (isPolling) {
    return (
      <Box padding="l">
        <SpaceBetween direction="vertical" size="m">
          <StatusIndicator type="loading">
            Processing {data?.entity_name}... ({displayCount}s)
          </StatusIndicator>
          <Box variant="small" color="text-body-secondary">
            This may take a few seconds. Please wait...
          </Box>
          <SpaceBetween direction="horizontal">
            <Box variant="small" color="text-body-secondary"> Request ID:</Box>
            <CopyToClipboard
      copyButtonAriaLabel="Request ID"
      copyErrorText="Request ID failed to copy"
      copySuccessText="Request ID copied"
      textToCopy={requestId}
      variant="icon"
    />
              <Box variant="small" color="text-body-secondary">{requestId}</Box>
          </SpaceBetween>
        </SpaceBetween>
      </Box>
    );
  }

  return <FirstPassResultComponent data={result} />;
};

export default FirstPassPollAndPullResults;
